import React from "react"
import HeaderSectionLeft from "./HeaderSectionLeft.jsx"
import HeaderSectionRight from "./HeaderSectionRight.jsx"
import TopRightPageBg from "../TopRightPageBg"

const HeaderSection = () => {
  return (
    <div className="relative bg-gradient_header overflow-hidden">
      <div
        className="flex w-full lg:max-w-w2_l xl:max-w-w2_xl justify-center items-center xl:items-start flex-col lg:flex-row gap-2 md:gap-8 px-4 md:px-px1_l xl:px-px1_xl pt-[40px] md:pt-[60px] mx-auto"
      >
        <HeaderSectionLeft />
        <HeaderSectionRight />
      </div>

      <TopRightPageBg />
    </div>
  );
};

export default HeaderSection;
